import { render, staticRenderFns } from "./sidebar-resume-block.vue?vue&type=template&id=0206cbe9&scoped=true"
import script from "./sidebar-resume-block.vue?vue&type=script&lang=js"
export * from "./sidebar-resume-block.vue?vue&type=script&lang=js"
import style0 from "./sidebar-resume-block.vue?vue&type=style&index=0&id=0206cbe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0206cbe9",
  null
  
)

export default component.exports